import React from "react";

import { Modal as AntModal } from "antd";

export const ModalContent = ({ children, visible, onCancel, type = "" }) => {
  const articleProps = {
    className: "article",
    style: {
      top: "1rem",
    },
    bodyStyle: {
      height: "calc(100vh -4rem)",
      marginTop: "3rem",
    },
  };

  const modalProps = {
    article: articleProps,
    dashboard: null,
  };

  return (
    <AntModal onCancel={onCancel} open={visible} footer={false} {...modalProps[type]}>
      {children}
    </AntModal>
  );
};

export default ModalContent;
